import { Box, VStack, Heading, Body, Container } from '@hover/blueprint';
import React from 'react';
import { ABOUT_SECTION_VALUES } from '../../../constants';

const Mobile: React.FC = () => (
  <Container px={200}>
    <VStack display={{ base: 'flex', desktop: 'none' }} spacing={900} mb={900}>
      {ABOUT_SECTION_VALUES.map(section => (
        <Box flexDir="column" key={section.id}>
          <Box maxW="380px" alignSelf="center" mb={500}>
            {section.image}
          </Box>
          <Heading mb={400} size={500} as="h3">
            {section.header}
          </Heading>
          <Body size={500} mb={500}>
            {section.body}
          </Body>
          <Body mb={500} size={500} isBold>
            {section.sub}
          </Body>
        </Box>
      ))}
    </VStack>
  </Container>
);

export default Mobile;
